import type { ComponentChildren } from "preact";
import { cn } from "./cn";

type Tone = "default" | "warning" | "danger" | "success";

const TONE_BORDER: Record<Tone, string> = {
  default: "border-border",
  warning: "border-warning-border",
  danger: "border-danger-border",
  success: "border-success-border",
};

export function Card({
  children,
  elevated = false,
  tone = "default",
  class: extraClass,
}: {
  children: ComponentChildren;
  elevated?: boolean;
  tone?: Tone;
  class?: string;
}) {
  return (
    <div
      class={cn(
        "rounded-lg bg-bg",
        "border",
        TONE_BORDER[tone],
        elevated && "shadow-xs",
        extraClass,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  children,
  class: extraClass,
}: {
  children: ComponentChildren;
  class?: string;
}) {
  return (
    <div
      class={cn(
        "border-b border-border-subtle px-5 py-4",
        extraClass,
      )}
    >
      {children}
    </div>
  );
}

export function CardBody({
  children,
  class: extraClass,
}: {
  children: ComponentChildren;
  class?: string;
}) {
  return <div class={cn("px-5 py-4", extraClass)}>{children}</div>;
}

export function CardFooter({
  children,
  class: extraClass,
}: {
  children: ComponentChildren;
  class?: string;
}) {
  return (
    <div
      class={cn(
        "border-t border-border-subtle bg-bg-subtle/60 px-5 py-3",
        extraClass,
      )}
    >
      {children}
    </div>
  );
}
